import { RotateCcwIcon } from 'lucide-react';

import { CustomerBookingConfirmation } from '@/app/(app)/customers/[id]/customer-booking-confirmation';
import { CustomerBookingFilters } from '@/app/(app)/customers/[id]/customer-booking-filters';
import { useCustomerBookingCtx } from '@/app/(app)/customers/[id]/customer-booking-provider';
import { CustomerBookingResults } from '@/app/(app)/customers/[id]/customer-booking-results';
import { Button } from '@/components/ui/button';

export function CustomerBooking() {
  const {
    selected,
    isAnyFilterSet: isAnyParamSet,
    clearFilters: clearParams,
    mode,
    cancelReschedule,
  } = useCustomerBookingCtx();
  if (selected) {
    return (
      <SidebarContainer>
        <CustomerBookingConfirmation />
      </SidebarContainer>
    );
  }

  return (
    <SidebarContainer>
      <div className='sticky top-0 z-10 flex w-full items-center border-b bg-background px-4 py-2'>
        <h2 className='text-heading-sm'>
          {mode === 'RESCHEDULE' && 'Reschedule Appointment'}
          {mode === 'NEW' && 'New Appointment'}
        </h2>
        <div className='ml-auto flex gap-2'>
          {mode === 'RESCHEDULE' && (
            <Button size='sm' variant='outline' onClick={cancelReschedule}>
              Cancel
            </Button>
          )}
          <Button size='sm' variant='outline' onClick={clearParams} disabled={isAnyParamSet}>
            <RotateCcwIcon className='size-4' />
            Clear All
          </Button>
        </div>
      </div>
      <div className='p-4'>
        <CustomerBookingFilters />
      </div>
      <div className='p-4'>
        <CustomerBookingResults />
      </div>
    </SidebarContainer>
  );
}

function SidebarContainer({ children }: { children: React.ReactNode }) {
  return <div className='no-scrollbar w-[474px] min-w-[474px] overflow-y-auto border-l-[0.5px]'>{children}</div>;
}
